export default {
	id: 'SIMPLE_PREMIUM_MALE_FALLBACK_3M_79_3M_15_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_3m_79_3m_15_99_usd',
			EUR: 'simple_premium_3m_69_3m_15_99_eur',
			GBP: 'simple_premium_3m_59_99_3m_23_99_gbp',
			AUD: 'simple_premium_3m_99_99_3m_35_19_aud',
			CAD: 'simple_premium_3m_99_99_3m_35_19_cad',
			DKK: 'simple_premium_3m_459_3m_183_2_dkk',
			SEK: 'simple_premium_3m_699_3m_279_2_sek',
			NOK: 'simple_premium_3m_699_3m_279_2_nok',
			BRL: 'simple_premium_3m_179_3m_55_2_brl',
			MXN: 'simple_premium_3m_999_3m_399_2_mxn',
			TRY: 'simple_premium_3m_1999_3m_799_2_try',
			ARS: 'simple_premium_3m_79990_3m_31992_ars',
			COP: 'simple_premium_3m_239990_3m_95992_cop',
			CLP: 'simple_premium_3m_57990_3m_23992_clp',
		},
		primer: 'prd_gDWuklWBRdkv',
	},
}
